import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import AboutBannerImg from '../assets/images/sell-banner.png';
import ArrowIcon from '../assets/images/button-arrow.svg';
import { Link } from "react-router-dom"

const SellBanner = () => {
   return (
    <section className="about-banner-section">
        <Row>
          <Col lg={6} md={12} className='about-content-box align-self-center'>
            <div className="about-content">
              <h1 className="about-title">
              Sell your home with<br/> <span>confidence</span>
              </h1>
              <p className="about-description">
              We give you multiple options to sell your home with the flexibility to choose what works best for your unique situation, timeline and goals.
              </p>
              <Link to={'/find-an-agent'} className='custom-bttn style-3 ani-1 right'>
                Find an Agent <img src={ArrowIcon} alt="Arrow Icon" />
              </Link>

            </div>
          </Col>
          <Col lg={6} md={12}>
            <div className="about-image">
              <img 
                src={AboutBannerImg}
                alt="Modern House" 
                className="house-img"
              />
            </div>
          </Col>
        </Row>
    </section>
  );
}

export default SellBanner;